const hoursArr = Array.from(Array(12).keys());
const minutes = ['00', '15', '30', '45'];
const dispHours = (hour: number, meridiem: string) =>
    minutes.map(minute => `${hour === 0 ? 12 : hour}:${minute} ${meridiem}`);

export const availableTimeslots = hoursArr
    .map(hour => dispHours(hour, 'AM'))
    .concat(hoursArr.map(hour => dispHours(hour, 'PM')))
    .reduce((a, b) => a.concat(b));



// WEBPACK FOOTER //
// ./src/utilities/timeslots.ts